const API_URL = process.env.REACT_APP_API_URL;

export interface CheckinPrompt {
  key: string;
  text: string;
  hint: string;
}

export interface CheckinData {
  id: string;
  sessionId: string;
  language: string;
  prompts: CheckinPrompt[];
  status: string;
}

export interface CheckinResponseItem {
  promptKey: string;
  transcription: string;
  method: "voice" | "text";
}

export class CheckinApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export const fetchCheckinByToken = async (
  token: string
): Promise<CheckinData> => {
  const response = await fetch(
    `${API_URL}/api/checkin?token=${encodeURIComponent(token)}`
  );

  if (!response.ok) {
    let errorMessage = "Failed to fetch check-in";
    try {
      const error = await response.json();
      errorMessage = error.error || errorMessage;
    } catch {}
    throw new CheckinApiError(errorMessage, response.status);
  }

  return response.json();
};

export const fetchDeepgramToken = async (
  checkinToken: string
): Promise<string> => {
  const response = await fetch(
    `${API_URL}/api/checkin/deepgram-token?token=${encodeURIComponent(checkinToken)}`
  );

  if (!response.ok) {
    let errorMessage = "Failed to fetch transcription token";
    try {
      const error = await response.json();
      errorMessage = error.error || errorMessage;
    } catch {}
    throw new CheckinApiError(errorMessage, response.status);
  }

  const data = await response.json();
  return data.key;
};

export const submitCheckin = async (
  token: string,
  responses: CheckinResponseItem[],
  language: string
): Promise<{ message: string; status: string }> => {
  const response = await fetch(`${API_URL}/api/checkin/submit`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, responses, language }),
  });

  if (!response.ok) {
    let errorMessage = "Failed to submit check-in";
    try {
      const error = await response.json();
      errorMessage = error.error || errorMessage;
    } catch {}
    throw new CheckinApiError(errorMessage, response.status);
  }

  return response.json();
};
